/*
 * 员工相关接口
 */
import request from '../request'

enum Api {
  LOGIN_API = 'staff/login',
  CHANGE_PWD = 'staff/updatePwd',
  LOGOUT_API = 'staff/loginOut',

  FORGET_PWD = 'staff/forgetPassword'
}

export default class AjaxAuthService {
  /**
   * 登录
   * @param data
   * @returns
   */
  static login(data: any): Promise<any> {
    return request.post(Api.LOGIN_API, data)
  }
  /**
   * 退出登录
   * @returns
   */
  static logOut(): Promise<any> {
    return request.post(Api.LOGOUT_API)
  }
  /**
   * 修改密码
   * @returns
   */
  static changePwd(data: any): Promise<any> {
    return request.post(Api.CHANGE_PWD, data)
  }

  /**
   * 设置新密码
   * @returns
   */
  static setPwd(data: any): Promise<any> {
    return request.post(Api.FORGET_PWD, data)
  }
}
